import { useCallback } from 'react';
import { VinculationWrapper } from '@coinscrap/webapp-core';


export const useGetUniqueToken = (userId, instance) => {
	const vinculationContext = VinculationWrapper.use();
	const vinculationApiInstance = instance || vinculationContext?.vinculationApiInstance;

	const getUniqueToken = useCallback(async () => {
		if (vinculationApiInstance) {
			const uniqueToken = await vinculationApiInstance.microserviceCall('Us')(
				`/users/${userId}/identity-providers/identifier/unique-identifier/token`,
				'POST',
				{},
			);

			if (!uniqueToken?.uniqueToken) {
				throw new Error('Error getting uniqueToken');
			}

			return uniqueToken?.uniqueToken;
		}
	}, [vinculationApiInstance, userId]);

	return getUniqueToken;
};
